import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    status: Yup.string()
      .nullable()
      .required("US.COLLECTION.VALIDATIONS:REQUIRED.STATUS_IS_REQUIRED"),

    informationList: Yup.array().of(
      Yup.object().shape({
        key: Yup.string()
          .nullable()
          .required("US.COLLECTION.VALIDATIONS:REQUIRED.HEADER_IS_REQUIRED")
          .test(
            "duplicate-key",
            "US.COLLECTION.VALIDATIONS:REQUIRED.DUPLICATE_HEADER_FOUND",
            function (value) {
              const { from }: any = this.options ?? {};

              // Get the index of the current item based on its path
              const currentIndex = Number(this.path.match(/\d+/)?.[0] ?? -1);

              const duplicateIndexes: any = from?.[1]?.value?.informationList
                .map((item: any, index: number) =>
                  item.key === value ? index : null
                )
                .filter((index: number) => index !== null);

              return !(
                duplicateIndexes.length > 1 &&
                duplicateIndexes[duplicateIndexes.length - 1] === currentIndex
              );
            }
          ),

        value: Yup.string()
          .nullable()
          .required("US.COLLECTION.VALIDATIONS:REQUIRED.VALUE_IS_REQUIRED"),
      })
    ),
  });
};
